<template>
  <div class=" bg-white rounded-lg shadow">
    <div class="flex">
      <h2 class="flex flex-grow justify-start text-primary-500 font-bold">
        Announcements
      </h2>
      <d-button v-if="hasRole('System Administrator') || hasRole('Consultant')" @click="gotoManageAnnouncements">
        Manage Announcements
      </d-button>
    </div>
    <hr class="border-2 border-primary-500 items-center">
    <div class="flex flex-col justify-between py-3 -mx-2">
      <template v-for="announcement in announcements">
        <div :key="announcement.id" class="w-full mb-6 px-3">
          <div class="rounded overflow-hidden  flex flex-col justify-between bg-white">
            <div class="flex h-15 justify-start w-full">
              <div class="px-6 py-4">
                <div class="font-bold text-xl mr-2 pb-5 ">
                  {{ announcement.title }} <br> {{ announcement.startShowingDate | formatShortDate }}
                </div>
                <div class="pb-5 wysiwyg-editor-container" v-html="announcement.html" />
                <div class="border border-primary-500" />
              </div>
            </div>
          </div>
        </div>
      </template>
      <div v-if="availableAnnouncementCountIsGreaterThanCurrentVisibleCount" class="flex items-center justify-center w-half">
        <a v-if="!loadingAnnouncements" class="py-2 px-4" :class="{'no-underline' : allAnnouncementsShown, 'cursor-pointer' : !allAnnouncementsShown}" :loading="loadingAnnouncements" @click="getUserAnnouncements">
          {{ allAnnouncementsShown ? '(No more announcements)' : 'Show more' }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import { mapGetters } from 'vuex';

  export default {
    parent: true,
    filters: {
      stripString(str) {
        return str.replace(/<[^>]+>/g, '');
      },
    },

    data: () => ({
      announcements: [],
      currentCount: 0,
      incrementCountByAmount: 5,
      allAnnouncementsCount: 0,
      loadingAnnouncements: false,
    }),

    computed: {
      ...mapGetters('d2Auth', ['profile', 'hasRole']),

      allAnnouncementsShown() {
        return this.currentCount >= this.allAnnouncementsCount;
      },
    },

    mounted() {
      this.getUserAnnouncements();
    },

    methods: {
      async getUserAnnouncements() {
        this.loadingAnnouncements = true;
        const { data } = await axios.get('/api/gateway/announcements');
        this.allAnnouncementsCount = data.length;
        this.currentCount += this.incrementCountByAmount;
        this.announcements = data.slice(0, this.currentCount);
        this.loadingAnnouncements = false;
      },

      availableAnnouncementCountIsGreaterThanCurrentVisibleCount() {
        return this.announcements.length > this.currentCount;
      },

      gotoManageAnnouncements() {
        window.location = '/admin/announcements';
      },

    },

  };
</script>